/**
 * Wishlist Functionality
 * localStorage-based wishlist voor Het Koffiepaleis
 */

(function() {
  'use strict';
  
  var STORAGE_KEY = 'koffiepaleis_wishlist';
  var wishlistStrings = window.wishlistStrings || {};

  function normalizeProductId(id) {
    if (id == null || id === '') {
      return '';
    }
    return String(id);
  }
  
  // Wishlist Class
  var Wishlist = {
    items: [],
    
    init: function() {
      this.items = this.load();
      this.normalizeStoredIds();
      this.updateAllButtons();
      this.updateCount();
      this.bindEvents();
      
      // Listen for storage changes from other tabs
      window.addEventListener('storage', function(e) {
        if (e.key === STORAGE_KEY) {
          Wishlist.items = Wishlist.load();
          Wishlist.normalizeStoredIds();
          Wishlist.updateAllButtons();
          Wishlist.updateCount();
          Wishlist.dispatchUpdate();
        }
      });
    },
    
    load: function() {
      try {
        var data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Wishlist load error:', e);
        return [];
      }
    },

    /** Zorg dat opgeslagen id's altijd strings zijn (JSON kan nummers bevatten). */
    normalizeStoredIds: function() {
      var changed = false;
      this.items = this.items.map(function(item) {
        if (!item || item.id == null) {
          return item;
        }
        var nid = normalizeProductId(item.id);
        if (item.id !== nid) {
          changed = true;
        }
        return Object.assign({}, item, { id: nid });
      });
      if (changed) {
        this.save();
      }
    },
    
    save: function() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
        this.dispatchUpdate();
      } catch (e) {
        console.error('Wishlist save error:', e);
      }
    },
    
    bindEvents: function() {
      // Click handler for wishlist buttons
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-wishlist-btn]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          Wishlist.handleToggle(btn);
        }
      });
    },
    
    handleToggle: function(btn) {
      var productId = normalizeProductId(btn.dataset.productId);
      
      if (this.contains(productId)) {
        this.remove(productId);
        this.showToast(wishlistStrings.removed || 'Removed from favourites');
      } else {
        this.add({
          id: productId,
          handle: btn.dataset.productHandle,
          title: btn.dataset.productTitle,
          image: btn.dataset.productImage,
          price: parseInt(btn.dataset.productPrice) || 0,
          url: btn.dataset.productUrl,
          addedAt: Date.now()
        });
        this.showToast(wishlistStrings.added || 'Added to favourites');
      }
      
      this.updateAllButtons();
      this.updateCount();
    },
    
    add: function(item) {
      var id = normalizeProductId(item.id);
      if (!id) {
        return;
      }
      var normalized = Object.assign({}, item, { id: id });
      if (!this.contains(id)) {
        this.items.push(normalized);
        this.save();
      }
    },
    
    remove: function(productId) {
      var needle = normalizeProductId(productId);
      this.items = this.items.filter(function(item) {
        return normalizeProductId(item.id) !== needle;
      });
      this.save();
      this.updateAllButtons();
    },
    
    contains: function(productId) {
      var needle = normalizeProductId(productId);
      if (!needle) {
        return false;
      }
      return this.items.some(function(item) {
        return normalizeProductId(item.id) === needle;
      });
    },
    
    getAll: function() {
      return this.items;
    },
    
    getCount: function() {
      return this.items.length;
    },
    
    clear: function() {
      this.items = [];
      this.save();
      this.updateAllButtons();
      this.updateCount();
    },
    
    updateAllButtons: function() {
      var self = this;
      document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
        var productId = normalizeProductId(btn.dataset.productId);
        var isInWishlist = self.contains(productId);
        btn.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
      });
    },
    
    updateCount: function() {
      var count = this.getCount();
      document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
        var link = el.closest('.header__icon--wishlist, .header__mobile-quick-link--wishlist');
        if (link) {
          link.classList.toggle('header__wishlist--has-items', count > 0);
        }
      });
    },

    dispatchUpdate: function() {
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: {
          items: this.getAll(),
          count: this.getCount()
        }
      }));
    },
    
    showToast: function(message) {
      // Remove existing toast
      var existingToast = document.querySelector('.wishlist-toast');
      if (existingToast) {
        existingToast.remove();
      }
      
      // Create new toast
      var toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      
      // Trigger animation
      requestAnimationFrame(function() {
        toast.classList.add('is-visible');
      });
      
      // Remove after delay
      setTimeout(function() {
        toast.classList.remove('is-visible');
        setTimeout(function() {
          if (toast.parentNode) {
            toast.remove();
          }
        }, 300);
      }, 2500);
    }
  };
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      Wishlist.init();
    });
  } else {
    Wishlist.init();
  }
  
  // Expose globally
  window.wishlist = Wishlist;
  
})();
